import React, { useState, useLayoutEffect, useEffect } from 'react';
import img8 from '../../assets/image/img-8.jpg';
import { fetchProducts } from '../../utils/apiService';

const Products = () => {
    const [activeItem, setActiveItem] = useState(null);
    const [products, setProducts] = useState([]);

    useLayoutEffect(() => {
        // Trigger animations for this section
        if (window.animationText) window.animationText();
        if (window.scrollingEffect) window.scrollingEffect();
        if (window.animateImgItem) window.animateImgItem();

        // Refresh ScrollTrigger as content might have changed
        if (window.ScrollTrigger) {
            window.ScrollTrigger.refresh();
        }
    }, [products]); // Re-run when products load

    useEffect(() => {
        const getProducts = async () => {
            const result = await fetchProducts();
            if (result && result.status && result.data) {
                setProducts(result.data);
                if (result.data.length > 0) {
                    setActiveItem(result.data[0].id); // Open first item by default
                }
            }
        };
        getProducts();
    }, []);

    const toggleItem = (id) => {
        setActiveItem(activeItem === id ? null : id);
    };

    return (
        <section className="section-company tf-spacing-3">
            <div className="tf-container w-1810">
                <div className="section-company-inner">
                    <div className="left-section">
                        <div className="heading-section mb-53">
                            <h2
                                className="title fw-6 title-animation"
                                dangerouslySetInnerHTML={{
                                    __html: `Our Developed <span class="fw-3">Products</span>`
                                }}
                            />
                        </div>
                        <div className="wg-according" id="According1">
                            {products.map((item) => (
                                <div className="according-item" key={item.id}>
                                    <h5 className="fw-5">
                                        <div
                                            className={`title-according ${activeItem !== item.id ? 'collapsed' : ''}`}
                                            onClick={() => toggleItem(item.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {item.title} <span></span>
                                        </div>
                                    </h5>
                                    <div className={`collapse ${activeItem === item.id ? 'show' : ''}`}>
                                        <div className="according-content">
                                            <div className="right">
                                                <div className="desc lh-30">
                                                    {item.description}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="right-section">
                        <div className="image image-section tf-animate-1">
                            <img src={img8} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Products;
